import { defineStore } from 'pinia';

interface State {
  readOnly: boolean;
  showMessageModal: boolean;
}

export const useSupportMessagesStore = defineStore('supportMessages', {
  state: () => ({
    readOnly: false,
    showMessageModal: false,
    unreadMessageCount: {} as Record<string, number>,
    lensSupportRequestId: ''
  } as State),
  actions: {
    setReadOnly(readOnly: boolean) {
      this.readOnly = readOnly;
    },
    setShowMessageModal(show: boolean) {
      this.showMessageModal = show;
    }
  }
});
